
import { language as lan_loginForm } from "./login-form";
import { language as lan_thirdPartyLogin } from "./third-party-login";

let language = {
    ...lan_thirdPartyLogin,
    ...lan_loginForm,

    LOGIN_WELCOME_TEXT: "Welcome To {{appName}}",
    LOGIN_NEW_TO_SITE_TEXT: "New To {{appName}} ?",
    LOGIN_SIGNUP_LINK: "Sign Up",
    LOGIN_FORGOT_PASSWORD_LINK: "Forgot Password",
    // 邮箱密码相同提示
    LOGIN_EMAIL_PASS_CONSISTENT_TITLE: "Change your password",
    LOGIN_EMAIL_PASS_CONSISTENT_CONTENT1: "Your password cannot be the same as your email address. Please click \"{{changePsdBtn}}\" to select a different password, or click \"{{cancelBtn}}\" to change your password later.",
    LOGIN_EMAIL_PASS_CONSISTENT_CONTENT2: "Your password cannot be the same as your account full name. Please click \"{{changePsdBtn}}\" to select a different password, or click \"{{cancelBtn}}\" to change your password later.",

    // 登录失败
    LOGIN_UNSUCCESSFUL_TITLE: "Login unsuccessful",

    


};

export { language }